









































import Vue from 'vue';
import router from '@/router/index'; 
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default Vue.extend({
    name: 'Login',
    data(){
        return{
            isDefaultState:true,
            isLoadingState:false,
            isSuccessState:false,
            usr_name:"",
            usr_password:"",
            error_msg:"",
            usernameButtonColor: "#1abc9c",
            passwordButtonColor: "#1abc9c",
        }
    },
    created(){
        //this.login_function();
    },
    methods: {
        /*
        promiseWithTimeout: (promise: any) => {
            let timeoutId; 
            const timeoutPromise = new Promise((_, reject) => {
                timeoutId = setTimeout(() => {
                reject(new Error('Request timed out'));
                }, 4000);
            })
            return {
                promiseOrTimeout: Promise.race([promise, timeoutPromise]),
                timeoutId,
            };
        },
        */
        login_function: async function(){

            var isEmptyUsername = true;
            var isEmptyPassword = true;

            if(this.usr_name == ""){
                this.usernameButtonColor = "#d50d0d";
                isEmptyUsername = true;
            }else{
                this.usernameButtonColor = "#1abc9c";
                isEmptyUsername = false;
            }

            if(this.usr_password == ""){
                this.passwordButtonColor = "#d50d0d";
                isEmptyPassword = true;
            }else{
                this.passwordButtonColor = "#1abc9c";
                isEmptyPassword = false;
            }

            if(!isEmptyUsername && !isEmptyPassword){
                var temp_usr_name = this.usr_name;
                var temp_usr_password = this.usr_password;

                //Use for hashing
                //const msgBuffer = new TextEncoder().encode(temp_usr_password);
                //const hashBuffer = await crypto.subtle.digest('SHA-256',msgBuffer);
                //const hashArray = Array.from(new Uint8Array(hashBuffer));
                //const hashHex = hashArray.map(b => b.toString(16).padStart(2,'0')).join('');
                //temp_usr_password = hashHex.toString();
                
                /*
                const fetch_promise = await fetch(`${this.$server_address}/Login`,
                {
                    method: "POST",
                    credentials: 'include',
                    headers: {
                        'Accept': 'application/json; charset=utf-8',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify( {"username":temp_usr_name,"password":temp_usr_password} )
                })
                .catch(
                    (err) => {
                        console.error(err);
                        this.error_msg = "An error has occur!"
                    }
                )
                
                if(fetch_promise){

                    if(fetch_promise.status == 401){
                        this.$store.commit('user_empty');  
                        this.error_msg = "Invalid email/password!" 
                        
                        this.isDefaultState=true;
                        this.isLoadingState=false;
                        this.isSuccessState=false;
                    }

                    this.isDefaultState=false;
                    this.isLoadingState=true;
                    this.isSuccessState=false;

                    setTimeout(
                        () => {
                            var json_promise = fetch_promise.json();

                            json_promise.then(
                                (data) => {
                                    console.log(data.isAuthorizeUser)
                                    if(data.isAuthorizeUser){
                                        this.$store.commit('user_login_authorize',{username:data.username});
                
                                        this.isDefaultState=false;
                                        this.isLoadingState=false;
                                        this.isSuccessState=true;
                                        setTimeout(
                                            () => {
                                                router.push({ name: 'Home'});
                                            },
                                            2000
                                        )

                                    }else{
                                        this.$store.commit('user_empty');  
                                        this.error_msg = "Invalid email/password!"  
                                        
                                        this.isDefaultState=true;
                                        this.isLoadingState=false;
                                        this.isSuccessState=false;
                                    }
                                } 
                            )
                        },
                        1000
                    )

                  
                }
                */ 

                fetch(`${this.$server_address}/Login`,
                {
                    method: "POST",
                    credentials: 'include',
                    headers: {
                        'Accept': 'application/json; charset=utf-8',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify( {"username":temp_usr_name,"password":temp_usr_password} )
                })
                .then(
                    function(res){ 
                        return res.json(); 
                    }
                )
                .then(
                    (data) => {
                        console.log(data.isAuthorizeUser)
                        if(data.isAuthorizeUser){
                            this.$store.commit('user_login_authorize',{username:data.username});
                            router.push({ name: 'Home'});
                        }else{
                            this.$store.commit('user_empty');  
                            this.error_msg = "Invalid email/password!"   
                        }
                    } 
                )
                .catch(
                    (err) => {
                        console.error(err);
                        this.error_msg = "An error has occur!"
                    }
                )
                
            }
        },
    },
    
});
